import { sum } from "lodash";
import { MedicareParentOrganization } from "@app/overviews/network-benchmarking-dashboard/medicare/filters";
import { printNumberAsString } from "@app/shared/waffles";
import { JSX } from "react";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";

interface MedicareNetworkPillProps {
  onParentOrganizationClick: (parentOrganization: MedicareParentOrganization) => void; 
  parentOrganization: MedicareParentOrganization;
  selected: boolean;
}

const MedicareNetworkPill = (props: MedicareNetworkPillProps): JSX.Element => {
  return (
    <div
      className={`benchmarking-network-pill d-inline-block ${props.selected && "selected"}`}
      id={`benchmarking-dashboard__network-filters--pill-${props.parentOrganization.parentOrganizationName?.replace(/\W/g, "")}`}
      onClick={() => props.onParentOrganizationClick(props.parentOrganization)}
    >
      <div className="parent-organization-text float-start">
        <div>
          <EllipsisTooltip
            text={props.parentOrganization.parentOrganizationName}
          />
          
        </div>
        <div className="text-muted">
          Membership: {printNumberAsString(sum(props.parentOrganization.hContracts.map(x => x.membership)), "---")}
        </div>
      </div>
      <div className="float-end">
        <span className="fa-stack fa-lg ms-2">
          <i className="fa fa-circle fa-stack-2x h-contract-count-circle" />
          <b className="fa-stack-1x h-contract-count-number">{props.parentOrganization.hContracts.length}</b>
        </span>
      </div>
    </div>
  );
}

export default MedicareNetworkPill;
